/**
 * covid19_dashboard copyright © 2020
 * Created by mauromarini on 31/07/20
 * Repository: http://github.com/marinimau/covid19_dashboard
 * Location: Baratili San Pietro
 */

let intervalSelectorFilter = [
    {
        state: '_1W',
        name: 'settimana',
        field: 7,
    },
    {
        state: '_1M',
        name: 'mese',
        field: 30,
    },
    {
        state: '_MAX',
        name: 'max',
        field: -1,
    }
];

export default intervalSelectorFilter;